import React from 'react';

export default function AboutSection() {
    return (
        <div className="about-section" style={{ paddingBottom: '20px' }}>
            <h3>About the Tail-Wag Index</h3>
            <p>
                This map identifies "Opportunity Gaps" for dog-friendly infrastructure in Coweta and Fayette counties, home to an estimated <strong>70,000+ dog population</strong>. We are planning to expand this project to cover all of Metro Atlanta soon.
            </p>
            <p>
                It measures the <strong>15-minute drive time supply gap</strong> to determine how many canine amenities (vets, parks, pet stores) are reachable from each neighborhood, adjusted for local economic factors and travel-time decay.
            </p>
            <p>
                <strong>Understanding the Colors:</strong> The map uses a color scale from <span style={{ color: '#fde725', fontWeight: 'bold' }}>Critical Service Gaps (Yellow)</span>, where the dog population far outweighs the accessible infrastructure, to <span style={{ color: '#440154', fontWeight: 'bold' }}>High Saturation (Purple)</span> denoting well-served areas.
            </p>
        </div>
    );
}
